var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27188_35363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0C29.0833 0 30.0208 0.395833 30.8125 1.1875C31.6042 1.97917 32 2.91667 32 4V22C32 23.0833 31.6042 24.0208 30.8125 24.8125C30.0208 25.6042 29.0833 26 28 26H19L11.1875 31.875C11.0625 31.9583 10.9167 32 10.75 32C10.25 32 10 31.75 10 31.25V26H4C2.91667 26 1.97917 25.6042 1.1875 24.8125C0.395833 24.0208 0 23.0833 0 22V4C0 2.91667 0.395833 1.97917 1.1875 1.1875C1.97917 0.395833 2.91667 0 4 0H28ZM30 22V4C30 3.45833 29.7917 3 29.375 2.625C29 2.20833 28.5417 2 28 2H4C3.45833 2 2.97917 2.20833 2.5625 2.625C2.1875 3 2 3.45833 2 4V22C2 22.5417 2.1875 23.0208 2.5625 23.4375C2.97917 23.8125 3.45833 24 4 24H12V28.75L17.8125 24.375L18.3125 24H28C28.5417 24 29 23.8125 29.375 23.4375C29.7917 23.0208 30 22.5417 30 22ZM17.5 15C17.8333 15 18 15.1667 18 15.5V16.5C18 16.8333 17.8333 17 17.5 17H8.5C8.16667 17 8 16.8333 8 16.5V15.5C8 15.1667 8.16667 15 8.5 15H17.5ZM23.5 9C23.8333 9 24 9.16667 24 9.5V10.5C24 10.8333 23.8333 11 23.5 11H8.5C8.16667 11 8 10.8333 8 10.5V9.5C8 9.16667 8.16667 9 8.5 9H23.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27188_35363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.490e78b5b670d285992b6e99a8e9e1e0.svg";
export { ForwardRef as ReactComponent };